import { useSearchParams } from 'react-router-dom';
import { PageTabs } from '@trinetra/shared';
import { useAuth } from '../contexts/AuthContext';
import UsersPage from './UsersPage';
import RolesPage from './RolesPage';

/**
 * Users + Roles merged into one admin surface, reached from the header user menu.
 * Each tab keeps its own RBAC gate, so a `roles.view`-only user lands on Roles.
 */
export default function UserManagementPage() {
  const { hasPermission } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    { key: 'users', label: 'Users', permission: 'users.view' },
    { key: 'roles', label: 'Roles', permission: 'roles.view' },
  ].filter((t) => hasPermission(t.permission));

  const requested = searchParams.get('tab');
  const active = tabs.some((t) => t.key === requested) ? (requested as string) : tabs[0]?.key;

  if (!active) {
    return <div className="text-muted-foreground">You don't have access to user management.</div>;
  }

  return (
    <div className="space-y-3">
      {/* Title + actions live in the title bar (each tab's page renders its own PageTitle). */}
      <div data-tour="user-management-tabs">
        <PageTabs
          tabs={tabs.map(({ key, label }) => ({ key, label }))}
          active={active}
          onChange={(key) => setSearchParams({ tab: key }, { replace: true })}
        />
      </div>

      {active === 'users' ? <UsersPage /> : <RolesPage />}
    </div>
  );
}
